<template>
  <div
    :class="[$store.state.user.userInfo.natureId == 1 || $store.state.user.userInfo.natureId == 3 || $store.state.user.userInfo.natureId == 4 ? 'containerHome' : 'containerUnit']"
  >
    <div class="unitTItle" v-show="$store.state.user.userInfo.natureId == 1 || $store.state.user.userInfo.natureId == 3 || $store.state.user.userInfo.natureId == 4">
      <div class="common-page common-head">
        <div class="common-page common-head-title">
          <i class="icon-tr--detailed" style="padding-right: 5px"></i>
          数据分析
        </div>
      </div>
    </div>
    <div class="containertContent">
      <div
        class="unitList"
        style="background-color: #fff;"
        v-show="$store.state.user.userInfo.natureId == 1 || $store.state.user.userInfo.natureId == 3 || $store.state.user.userInfo.natureId == 4"
      >
        <unitList @select="getUnit" @getFirst="getOne"></unitList>
      </div>

      <div class="grid-container">
        <div class="item1 selectName">{{ company }}</div>
        <div class="item2">
          <div class="title mt0">算法评分</div>
          <reportScore :cpNum="cpNum"></reportScore>
        </div>

        <div class="item3">
          <div class="title mt0">报警概览</div>
          <reportAlarm :cpNum="cpNum"></reportAlarm>
        </div>

        <div class="item4">
          <div class="fireAlarm">
            <div class="title mt0">火警数量趋势图</div>
            <reportTrend :cpNum="cpNum"></reportTrend>
          </div>

          <div class="waterVideoSystem">
            <div class="title mt0">
              <div v-if="$store.state.user.showWater" class="water">水系统检测</div>
              <div v-if="$store.state.user.showVideo" class="video">视频监控</div>
            </div>
            <div class="waterChart" v-if="$store.state.user.showWater">
              <reportWaterSystem :cpNum="cpNum"></reportWaterSystem>
            </div>
            <div class="videoList" v-if="$store.state.user.showVideo">
              <reportVideo :cpNum="cpNum"></reportVideo>
            </div>
          </div>
        </div>

        <div class="item5">
          <div class="title mt0">
            <span>CRT点位</span>
            <router-link to="/building">
              <img
                style="padding-left: 1%;"
                src="@/assets/img/report/BIM.png"
                alt=""
                v-if="cpNum == 'ae5d8c2a5ed7470c8b08fafa1524dfce' || cpNum == '93fe79c642aa44e182aa3c793dfc9b55'"
              />
            </router-link>
          </div>

          <reportCrt :cpNum="cpNum"></reportCrt>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 组件
import unitList from '@/components/unitList';
import reportScore from './unitPage/report-score.vue';
import reportAlarm from './unitPage/report-alarmOverview.vue';
import reportTrend from './unitPage/report-fireTrend.vue';
import reportWaterSystem from './unitPage/report-waterSystem.vue';
import reportVideo from './unitPage/report-video.vue';
import reportCrt from './unitPage/report-crt.vue';
export default {
  components: { unitList, reportScore, reportAlarm, reportTrend, reportWaterSystem, reportVideo, reportCrt },
  data() {
    return {
      cpNum: '',
      company: this.$local.get('company')?.c_name,
      loading: true,
    };
  },
  watch: {
    cpNum() {
      const name = this.$local.get('company').c_name;
      this.company = name;
    },
  },

  // created: {},

  // mounted() {},

  methods: {
    getOne(v) {
      this.cpNum = v;
      this.company = '请选择单位';
    },
    getUnit(v) {
      this.cpNum = v;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/analysisUnit/analysisUnit.css';
</style>
